import DefaultDocument from '@tiptap/extension-document';

export const OneLineDocument = DefaultDocument.extend({
    content: 'paragraph',
});
